<template>

    <div>
<!--        <van-nav-bar :title="title" ></van-nav-bar>-->
        <van-tabs v-model="active" sticky>
            <van-tab  title="账单列表">
                <fin-report></fin-report>
            </van-tab>
            <van-tab  title="在途账单">
                <trans-fin-list :qry-data="qryData" :refresh-index="refreshIndex" :title-is-show="false"></trans-fin-list>
            </van-tab>
            <van-tab  title="分期账单">
                <credit-report :refresh-index="refreshIndex"></credit-report>
            </van-tab>
        </van-tabs>
    </div>

</template>

<script>

    import FinReport from "./report/FinReport";
    import TransFinList from "./report/TransFinList";
    import CreditReport from "./report/CreditReport";
    export default {
        name: "ReportPage",
        components: {
            FinReport,
            TransFinList,
            CreditReport
        },
        data(){
            return {
                //title:'记账',
                active:0,
                refreshIndex: 0,
                qryData:{
                    billTypes: [20101,20102],
                    billStatus: 21100
                }
            }
        }
    }
</script>

<style scoped>

</style>
